import React, { useState, useEffect } from 'react';
import axios from '../../axios';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { Card, CardContent } from '../../components/ui/card';

export default function BanksList() {
  const navigate  = useNavigate();
  const companyId = parseInt(localStorage.getItem('companyId'), 10);

  const [banks, setBanks] = useState([]);

  const fetchBanks = () => {
    axios.get(`/Bank/by-company/${companyId}`)
      .then(r => setBanks(r.data))
      .catch(console.error);
  };

  useEffect(() => {
    fetchBanks();
  }, [companyId]);

  const handleDelete = id => {
    if (window.confirm('هل أنت متأكد من حذف هذا البنك؟')) {
      axios.delete(`/Bank/${id}`)
        .then(fetchBanks)
        .catch(err => {
          console.error(err);
          alert('❌ حدث خطأ أثناء الحذف');
        });
    }
  };

  return (
    <Card className="max-w-6xl mx-auto mt-10" dir="rtl">
      <CardContent>
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-2xl font-bold">قائمة البنوك</h2>
          <Button onClick={() => navigate('/banks/new')}>➕ بنك جديد</Button>
        </div>
        <table className="w-full table-auto text-sm border-collapse">
          <thead>
            <tr className="bg-gray-100">
              {['#','الاسم','شركة','فرع','كود الحساب','نسبة الخصم','POS','إجراءات']
                .map((h,i) => (
                  <th key={i} className="px-2 py-1 border text-center">{h}</th>
                ))
              }
            </tr>
          </thead>
          <tbody>
            {banks.map((b,index) => (
              <tr key={b.id} className="even:bg-gray-50">
                <td className="px-2 py-1 border text-center">{index+1}</td>
                <td className="px-2 py-1 border">{b.name}</td>
                <td className="px-2 py-1 border">{b.companyName}</td>
                <td className="px-2 py-1 border">{b.branchName}</td>
                <td className="px-2 py-1 border text-center">{b.accCode}</td>
                <td className="px-2 py-1 border text-center">{b.disPre?.toFixed(2)}</td>
                <td className="px-2 py-1 border text-center">{b.changeInPOS ? '✔️' : '—'}</td>
                <td className="px-2 py-1 border text-center space-x-1 space-x-reverse">
                  <Button size="icon" onClick={() => navigate(`/banks/${b.id}`)}>✏️</Button>
                  <Button 
                    size="icon" 
                    variant="outline" 
                    onClick={() => handleDelete(b.id)}
                  >🗑️</Button>
                </td>
              </tr>
            ))}
            {banks.length === 0 && (
              <tr>
                <td colSpan={9} className="py-4 text-center text-gray-500">
                  لا توجد بيانات
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </CardContent>
    </Card>
  );
}
